module.exports = __webpack_public_path__ + "img/carte-cadeaux.2c1c7ccd.jpg";